<template>
	<div class="intentRegister">
		<img src="/tjkStudy/static/yxdj.png" class="banner" />
		<el-form ref="form" :model="form" class="intent-content">
			<template v-for="(item, key) in voList">
			  <el-form-item :label="key+1+'、'+item.question" v-if="voList.length>0" :class="{'is-required': item.requiredStatus == 'YES'}">
			    <template v-if="item.questionType == 'TEXT'">
			    	<el-input v-model="form.answerList[item.questionId]"></el-input>
			    </template>
			    <template v-if="item.questionType == 'MULTIPLE_TEXT'">
			    	<el-input v-model="form.answerList[item.questionId]" type="textarea" autosize></el-input>
			    </template>
			    <template v-if="item.questionType == 'SINGLE_CHOICE'">
			    	<el-radio-group v-model="form.answerList[item.questionId]">
			    		<template v-for="s in item.choiceList" >
			    			<el-radio :label="s.choiceContent"></el-radio>
			    		</template>
				    </el-radio-group>
			    </template>
			    <template v-if="item.questionType == 'MULTIPLE_CHOICE'">
			    	<el-checkbox-group v-model="form.answerList[item.questionId]">
			    		<template v-for="m in item.choiceList">
			    			<el-checkbox :label="m.choiceContent"></el-checkbox>
			    		</template>
				    </el-checkbox-group>
			    </template>
			    <template v-if="item.questionType == 'BLANK_CHOICE'">
						<el-select v-model="province" clearable placeholder="请选择省份" style="width: 170px;" @change="queryCitysFun">
		          <el-option v-for="(item, key) in provinceList" :key="key" :label="item.provinceName" :value="item.provinceName"></el-option>
		        </el-select>
		        <el-select v-model="city" clearable placeholder="请选择地市" style="width: 170px;">
		          <el-option v-for="(item, key) in citysList" :key="key" :label="item.citysName" :value="item.citysName"></el-option>
		        </el-select>
			    </template>
			    <template v-if="item.questionType == 'IMAGE'">
			    	<el-upload action="//upload-z0.qiniup.com" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :data="token" :before-upload="getToken" :on-success="uploadSuccess" :file-list="fileList" :limit="item.wordLimit">
              <i class="el-icon-plus"></i>
            </el-upload>
			    </template>
			  </el-form-item>
			</template>
		  <p class="btn"><el-button type="primary" @click="submitInfo">提交</el-button></p>
		</el-form>
		<el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" />
		</el-dialog>
	</div>
</template>

<script>
import data from './../../static/json/provinces.json'
	export default {
		data() {
			return {
				uid: '',
				voList:'',
				form: {
					answerList: []
				},
				province: '',
				city: '',
				provinceList: [],
				citysList: [],
				imgurl: [], //上传图片数据
				fileList: [], //已上传列表
	      token: null,
	      uploaderDomain: null,
				index: '', //查找省份和城市的questionId
				imgindex: '', //查找上传图片的questionId
				dialogImageUrl: '',
        dialogVisible: false
			}
		},
		watch: {
			voList: function() {
				for(var i=0;i<this.voList.length;i++) {
					if(this.voList[i].questionType == 'MULTIPLE_CHOICE') {
						this.form.answerList[this.voList[i].questionId] = []
					}
					if(this.voList[i].questionType == 'BLANK_CHOICE') {
						this.index = this.voList[i].questionId
					}
					if(this.voList[i].questionType == 'IMAGE') {
						this.imgindex = this.voList[i].questionId
					}
				}
			},
			province: function() {
				if(!this.province) {
					this.city = ''
					this.citysList = []
				}
			}
		},
		mounted() {
			this.provinceList = data.provinces
			this.queryList()
		},
		methods: {
			//根据省份查询地市
			queryCitysFun() {
				this.provinceList.map((item) => {
					if(item.provinceName == this.province) {
						this.citysList = item.citys
					}
				})
			},
			queryList() {
	      this.$http.post(API_ROOT.provider + '/intentRegister/queryQuestion', {'surveyId': 1}).then(respones=> {
	        var result = respones.data
	        if(result.success) {
	          if(result.data) {
	          	this.uid = result.data.surveyInfo.uid
	            this.voList = result.data.voList
	          }
	        }else {
	          this.$alert(result.msg)
	        }
	      },respones=> {
	        this.$alert("网络繁忙，请稍后重试！")
	      })
	    },
	    submitInfo() {
	    	var self = this,
	    			answerList = []
	    	if(this.form.answerList.length < this.voList.length) {
	    		this.$alert('你还有必填项未填')
	    		return false
	    	}
	    	this.form.answerList.forEach((v,i)=>{
	    		if($.isArray(v)) {
	    			answerList.push({'questionId': i, 'answer': JSON.stringify(v)})
	    		}else {
	    			answerList.push({'questionId': i, 'answer': v})
	    		}
        })
        if(!this.city) {
        	this.$alert('请选择所在城市')
	    		return false
        }
        if(this.imgurl.length == 0) {
        	this.$alert('请上传图片')
	    		return false
        }
        answerList.push({'questionId': this.index, 'answer': this.province+'-'+this.city})
        answerList.push({'questionId': this.imgindex, 'answer': JSON.stringify(this.imgurl)})
        var data = {
        	'surveyId': 1,
        	'uid': this.uid,
        	'answerList': answerList
        }
	    	this.$http.post(API_ROOT.provider + '/intentRegister/submit', data).then(respones=> {
	        var result = respones.data
	        if(result.success) {
	          self.$message({
              message: '登记成功',
              type: 'success',
              center: true,
              duration: 1000
            })
	        }else {
	          this.$alert(result.msg)
	        }
	      },respones=> {
	        this.$alert("网络繁忙，请稍后重试！")
	      })
	    },
	    handleRemove(file, fileList) {
	      this.imgurl = []
	      this.fileList = []
	      fileList.map((item)=> {
	        if(item.response) {
	          this.imgurl.push(this.uploaderDomain + '/' + item.response.key)
	          this.fileList.push({'url': this.uploaderDomain + '/' + item.response.key})
	        }else {
	          this.imgurl.push(item.url)
	          this.fileList.push({'url': item.url})
	        }
	      })
	    },
	    //获取文件后缀名
	    getSuffix(file) {
	      var lastPlace = file.lastIndexOf("."),
	          fileLength = file.length;
	      return file.substring(lastPlace + 1, fileLength)    
	    },
	    //获取上传七牛token
	    getToken(file) {
	      return this.$http.post(API_ROOT.method + '/qiniu/token', {ext: this.getSuffix(file.name)}).then((res) => {
	        var res = res.data
	        if( res.success ) {
	          this.token = {
	            key: res.data.key,
	            token: res.data.token
	          }
	          this.uploaderDomain = res.data.domain
	        } else {
	          this.$alert('上传图片失败!', '警告')
	        }
	      },(err) => {
	        this.$alert('上传图片失败!', '警告')
	      })
	    },
	    //上传七牛成功执行回调函数
	    uploadSuccess(response, file, fileList) {
	      var uploadUrl = this.uploaderDomain + '/' + response.key
	      this.imgurl.push(uploadUrl)
	    },
	    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
		}
	}
</script>



// WEBPACK FOOTER //
// ./src/page/intentRegister.vue